<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section
        class="content"
        v-show="showText"
        style="
          margin: 2px;
          background: rgba(0, 136, 255, 0.1);
          border: 1px solid #0094ff;
          display: flex;
          min-height: 0;
          margin: 10px 0;
        "
      >
        <div>
          <a-icon
            :style="{
              fontSize: '16px',
              color: '#1890ff',
              marginTop: '2px',
              marginLeft: '4px',
            }"
            type="exclamation-circle"
            theme="twoTone"
          />
        </div>
        <a-row style="margin-left: 1%; font-size: 14px">
          <a-col>{{ $t(`layer.InventoryLayer14`) }}</a-col>
        </a-row>
      </section>
      <section style="margin-bottom: 1%">
        <a-button type="primary" @click="goToAddPurchaseOrder(false)">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('form.AddPurchaseReturn') }}
        </a-button>
      </section>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-input
            allow-clear
            v-model.trim="formData.purchaseOrderSn"
            :placeholder="
              $t(`form.PleaseEnter`) + $t(`form.PurchaseReturns`) + $t(`form.OrderNumber`)
            "
          />
        </a-col>
        <a-col :span="8">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseOrderStart"
            :placeholder="$t(`form.OrderTime`)"
            :start-time="formData.startTime"
            :end-time="formData.endTime"
            ref="createdRange"
          ></date-range-picker>
        </a-col>

        <a-col :span="8">
          <!-- 仓库名称选项 -->
          <SelectWarehouseNew
            :placeholder="$t(`form.warehouseName`) + '（' + $t(`form.SingleChoice`) + '）'"
            style="width: 100%"
            :code.sync="formData.warehouseCode"
            @change="chooseWarehouse"
          />
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="8">
          <a-input
            allow-clear
            v-model.trim="formData.barcode"
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.ProductBarcode`)"
          />
        </a-col>
        <a-col :span="8">
          <date-range-picker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseDeliveryStart"
            :placeholder="$t(`form.DeliveryTime`)"
            :start-time="formData.deliveryTimeStart"
            :end-time="formData.deliveryTimeEnd"
            ref="deliveryRange"
          ></date-range-picker>
        </a-col>
        <a-col :span="8">
          <a-input
            allow-clear
            v-model.trim="formData.createdUser"
            :placeholder="$t(`form.PleaseEnter`) + $t(`创建人`)"
          />
        </a-col>
      </a-row>
      <a-row :gutter="24" style="margin-top: 15px">
        <a-col :span="8">
          <a-select
            allow-clear
            style="width: 100%"
            v-model="formData.canPlatformRefund"
            :placeholder="$t('是否支持平台退款')"
          >
            <a-select-option value="true">{{ $t('是') }}</a-select-option>
            <a-select-option value="false">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8">
          <a-select
            allow-clear
            style="width: 100%"
            v-model="formData.hasAppliedPlatformRefund"
            :placeholder="$t('是否已申请平台退款')"
          >
            <a-select-option value="true">{{ $t('是') }}</a-select-option>
            <a-select-option value="false">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8" class="platform-refund-quick">
          <a-checkbox v-model="canRefundPending">
            {{ $t('待申请平台退款') }}
          </a-checkbox>
        </a-col>
      </a-row>
      <a-row style="margin-top: 15px">
        <a-col :span="8">
          <a-button @click="queryOrderList(1)" class="btnBgc">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`form.Search`) }}
          </a-button>
          <a-button @click="resetFn" style="margin-left: 15px">
            <a-icon type="sync" />
            {{ $t(`form.Reset`) }}
          </a-button>
          <a-button @click="onExport" style="margin-left: 15px">
            <i class="icon iconfont icon-upload" style="margin-right: 5px"></i>
            {{ $t(`form.Export`) }}
          </a-button>
        </a-col>
      </a-row>

      <div class="table-content">
        <div class="table-header">
          <div class="row status-list-wrap">
            <input type="hidden" v-model="formData.status" />
            <a-tabs :active-key="activeStatusKey" @change="setSearchStatus">
              <a-tab-pane key="">
                <template slot="tab">
                  <span>{{ $t('form.All') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane :key="item" v-for="item in purchaseReturnStatusList">
                <template slot="tab">
                  <span>{{ $t(`form.${item}`) }}</span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <ul class="action-list" v-show="tableData.length">
            <li style="margin-right: 15px">
              <!-- 批量审核 -->
              <a-button class="btnBgc" @click="batchCheck">
                {{ $t(`form.Review`) }}
              </a-button>
            </li>
            <!-- 批量推送 -->
            <li style="margin-right: 15px">
              <a-button class="btnBgc" @click="batchPush">
                {{ $t(`form.Push`) }}
              </a-button>
            </li>
            <li style="margin-right: 15px">
              <!-- 批量作废 -->
              <a-button class="btnBgD" @click="batchCancel">
                {{ $t(`form.Void`) }}
              </a-button>
            </li>
          </ul>
        </div>
        <div class="table-body">
          <a-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :scroll="{ x: 1500 }"
            :columns="tableColumns"
            :data-source="tableData"
            @change="headerOperation"
            rowKey="supplierReturnOrderId"
            :pagination="false"
            :loading="tableLoading"
            bordered
          >
            <template slot="supplierReturnOrderSn" slot-scope="text, record">
              <a-tag v-if="record.canPlatformRefund" color="blue">
                {{ $t('支持平台退款') }}
              </a-tag>
              <div class="mt4">
                <a @click="onCliCkDetail(record.supplierReturnOrderId)">
                  {{ record.supplierReturnOrderSn }}
                </a>
              </div>
            </template>
            <template slot="time" slot-scope="text, record">
              <div>
                <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.createdAt }}</div>
                <div class="time-item" v-if="record.deliveryTime">
                  {{ $t('form.DeliveryTime') }}：{{ record.deliveryTime }}
                </div>
              </div>
            </template>
            <!-- 退货数量 -->
            <template slot="PurchaseQuantity" slot-scope="text, record">
              {{ record.totalCount | toThousands }}
            </template>
            <!-- 状态 -->
            <template slot="status" slot-scope="text, record">
              {{ $t(`form.${record.status}`) }}
            </template>
            <!-- 平台退款单汇总，点击查看明细 -->
            <template slot="platformRefund" slot-scope="text, record">
              <div v-if="record.platformRefundOrders && record.platformRefundOrders.length">
                <a @click="openPlatformRefundModal(record)">
                  {{ record.platformRefundOrders.length }} {{ $t('单') }}
                </a>
                <div class="time-item">
                  {{ $t('已退款金额') }}：{{
                    sumRefundedAmount(record.platformRefundOrders) | toThousands
                  }}
                </div>
              </div>
              <span v-else>-</span>
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
    <a-modal v-model="visible" :title="modalInfo.modalTitle" :width="500" :footer="null">
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :multiple="true"
          :action="modalInfo.modalUrl"
          :data="{ buId: buId, shopCode: shopCode }"
          :headers="{ Authorization: sessionId }"
          @change="handleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          target="_blank"
          class="text-info mt10"
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }}{{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
    <PlatformRefundRecordModal
      :visible.sync="platformRefundVisible"
      :orders="currentPlatformRefundOrders"
    />
  </div>
</template>
<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapState, mapMutations } from 'vuex'
import pagination from '@component/pagination'
import dateRangePicker from '@component/dateRangePicker'
import { Modal } from 'ant-design-vue'
import { getCookie } from '@/common/cookie'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import PlatformRefundRecordModal from '@component/platformRefundRecordModal.vue'
export default {
  name: 'purchaseList',
  mounted() {
    this.queryOrderList()
    this.sessionId = getCookie('d_session_id')
  },
  activated() {
    this.queryOrderList()
  },
  components: {
    pagination,
    dateRangePicker,
    SelectWarehouseNew,
    PlatformRefundRecordModal,
  },
  data() {
    return {
      shopCode: '',
      sessionId: '',
      status: '',
      activeStatusKey: '',
      formData: {
        purchaseOrderSn: '',
        referenceNo: '',
        startTime: '',
        endTime: '',
        status: '',
        warehouseCode: '',
        tag: '',
        canPlatformRefund: undefined,
        hasAppliedPlatformRefund: undefined,
      },
      pageNo: 1,
      pageSize: 10,
      orderByParam: 'created_at DESC',
      total: 0,
      selectedRowKeys: [],
      tableData: [],
      tableLoading: false,
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: '',
        xlsRequestUrl: '',
        xlsDownloadUrl:
          'https://erp-prod.oss-ap-southeast-1.aliyuncs.com/cloud_bird_oss_gRDnXV93qPU2SDCp/SCM/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx', //模板下载链接
      },
      visible: false,
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      showText: false,
      platformRefundVisible: false,
      currentPlatformRefundOrders: [],
    }
  },
  computed: {
    ...mapState(['purchaseReturnStatusList']),
    // 一键组合筛选：支持平台退款且未申请（能退要退）
    canRefundPending: {
      get() {
        return (
          this.formData.canPlatformRefund === 'true' &&
          this.formData.hasAppliedPlatformRefund === 'false'
        )
      },
      set(val) {
        this.formData.canPlatformRefund = val ? 'true' : undefined
        this.formData.hasAppliedPlatformRefund = val ? 'false' : undefined
        this.queryOrderList(1)
      },
    },
    tableColumns() {
      return [
        {
          dataIndex: 'purchaseOrderSn',
          title: this.$t('退货单号'),
          key: 'supplierReturnOrderSn',
          width: 180,
          scopedSlots: { customRender: 'supplierReturnOrderSn' },
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 240,
          scopedSlots: { customRender: 'time' },
        },
        {
          title: this.$t('form.SupplierName'),
          key: 'supplierName',
          dataIndex: 'supplierName',
          width: 150,
        },
        {
          title: this.$t('退货数量'),
          key: 'totalReturnQuantity',
          width: 150,
          dataIndex: 'totalReturnQuantity',
        },
        {
          title: this.$t('退货仓库'),
          key: 'warehouseName',
          width: 120,
          dataIndex: 'warehouseName',
        },
        {
          title: this.$t('form.DeliveryOrderNo'),
          key: 'wmsOrderSn',
          width: 150,
          dataIndex: 'wmsOrderSn',
        },
        {
          title: this.$t('form.Status'),
          key: 'status',
          dataIndex: 'status',
          width: 150,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('平台退款单'),
          key: 'platformRefund',
          dataIndex: 'platformRefundOrders',
          width: 170,
          scopedSlots: { customRender: 'platformRefund' },
        },
        {
          title: this.$t('创建人'),
          key: 'createdUser',
          dataIndex: 'createdUser',
          width: 120,
          customRender: (text) => decodeURIComponent(text),
        },
      ]
    },
    buId() {
      return this.$store.getters.partyId
    },
    lang() {
      return this.$store.state.lang
    },
  },
  methods: {
    ...mapMutations(['addPane']),

    chooseWarehouse(value) {
      //选择仓库
      if (value) {
        this.formData.warehouseCode = value
      } else {
        this.formData.warehouseCode = ''
      }
    },
    onCliCkDetail(id) {
      this.$router.push({
        name: 'addPurchaseReturn',
        query: { id },
      })
    },
    // 下拉筛选值（'true'/'false' 字符串）转成布尔，未选则为 undefined（不传）
    toBoolOrUndefined(value) {
      if (value === 'true' || value === true) return true
      if (value === 'false' || value === false) return false
      return undefined
    },
    openPlatformRefundModal(record) {
      this.currentPlatformRefundOrders = record.platformRefundOrders || []
      this.platformRefundVisible = true
    },
    sumRefundedAmount(orders) {
      return (orders || []).reduce((sum, item) => sum + (Number(item.refundedAmount) || 0), 0)
    },
    chooseOrderStart(date) {
      this.formData.startTime = date.start_time
      this.formData.endTime = date.end_time
    },
    chooseDeliveryStart(date) {
      this.formData.deliveryTimeStart = date.start_time
      this.formData.deliveryTimeEnd = date.end_time
    },
    onExport() {
      let currentShop = JSON.parse(localStorage.getItem('currentShop'))
      let mergeCode = currentShop?.uniqueCode
      let merchantShopName = currentShop?.name
      let appCode = localStorage.getItem('appCode')
      let merchantCode = JSON.parse(localStorage.getItem('userSession')).merchantCode
      let data = {
        bookCode: 'supplierReturnOrderExport',
        group: '',
        mergeCode,
        merchantShopName,
        appCode,
      }
      if (this.selectedRowKeys.length) {
        let params = {
          supplierReturnOrderIds: this.selectedRowKeys,
          merchantCode,
        }
        data.params = params
      } else {
        let params = {
          supplierReturnOrderSn: this.formData.purchaseOrderSn,
          createdAtStart: this.formData.startTime,
          createdAtEnd: this.formData.endTime,
          warehouseCode: this.formData.warehouseCode,
          barcode: this.formData.barcode,
          deliveryTimeStart: this.formData.deliveryTimeStart,
          deliveryTimeEnd: this.formData.deliveryTimeEnd,
          createdUser: this.formData.createdUser,
          orderByParam: this.orderByParam,
          merchantCode,
        }
        data.params = params
      }
      http({
        instance: this,
        url: api.taskCreate + `?language=${this.language_mapping[this.lang]}`,
        data: data,
        type: 'post',
        hasLoading: false,
        success: (res) => {
          console.log(res)
          if (res.result.task_id) {
            this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
          } else {
            this.$message.error(this.$t('创建导出任务失败'))
          }
        },
      })
    },
    goToAddPurchaseOrder() {
      this.$router.push('addPurchaseReturn')
    },
    queryOrderList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.$nextTick(async () => {
        let data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          supplierReturnOrderSn: this.formData.purchaseOrderSn,
          createdAtStart: this.formData.startTime,
          createdAtEnd: this.formData.endTime,
          warehouseCode: this.formData.warehouseCode,
          barcode: this.formData.barcode,
          deliveryTimeStart: this.formData.deliveryTimeStart,
          deliveryTimeEnd: this.formData.deliveryTimeEnd,
          createdUser: this.formData.createdUser,
          orderByParam: this.orderByParam,
          canPlatformRefund: this.toBoolOrUndefined(this.formData.canPlatformRefund),
          hasAppliedPlatformRefund: this.toBoolOrUndefined(this.formData.hasAppliedPlatformRefund),
        }
        if (this.formData.status !== -1) {
          data.status = this.formData.status
        }
        this.tableLoading = true
        let res = await http({
          instance: this,
          type: 'post',
          url: api.supplierReturnOrderList,
          hasLoading: true,
          data,
        })
        let supplierReturnOrderList = [...(res.result.supplierReturnOrderList || '')]
        this.tableData = supplierReturnOrderList
        this.total = res.result.total
        this.tableLoading = false
      })
    },
    resetFn() {
      this.pageNo = 1
      this.pageSize = 10
      this.activeStatusKey = ''
      this.selectedRowKeys = []
      this.orderByParam = 'created_at DESC'
      this.formData.purchaseOrderSn = ''
      this.formData.referenceNo = ''
      this.formData.startTime = ''
      this.formData.endTime = ''
      this.formData.warehouseCode = ''
      this.formData.barcode = ''
      this.formData.deliveryTimeStart = ''
      this.formData.deliveryTimeEnd = ''
      this.formData.createdUser = ''
      this.formData.status = ''
      this.formData.tag = ''
      this.formData.canPlatformRefund = undefined
      this.formData.hasAppliedPlatformRefund = undefined
      this.$refs.createdRange && this.$refs.createdRange.clear()
      this.$refs.deliveryRange && this.$refs.deliveryRange.clear()
      this.queryOrderList(1)
    },
    setSearchStatus(status) {
      this.activeStatusKey = status
      this.$set(this.formData, 'tag', '')
      this.$set(this.formData, 'status', status)
      this.queryOrderList(1)
      this.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 排序
    headerOperation(pagination, filters, sorter = {}) {
      const { columnKey, order } = sorter
      if (columnKey === 'OrderTime') {
        this.orderByParam = order === 'ascend' ? 'created_at ASC' : 'created_at DESC'
        this.queryOrderList()
      }
    },
    batchCheck() {
      this.batchHandle({
        modalAction: this.$t('form.Review'),
        url: api.supplierReturnOrderBatchCheck,
      })
    },
    batchCancel() {
      this.batchHandle({
        modalAction: this.$t('form.Void'),
        url: api.supplierReturnOrderBatchCancel,
      })
    },
    batchPush() {
      if (this.confirmSelect()) return

      Modal.confirm({
        title: this.$t('form.Tips'),
        content: `${this.$t('是否推送选中订单')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          let supplierReturnOrderIds = [...this.selectedRowKeys]
          http({
            hasLoading: true,
            url: api.supplierReturnOrderBatchPush,
            data: { supplierReturnOrderIds },
            success: (res) => {
              let result = res.result
              if (result?.failPushedMsgs?.length) {
                let err = result.failPushedMsgs.join(',')
                this.$error(err)
              } else {
                this.$success({
                  title: this.$t(`layer.Success`),
                  content: this.$t('推送成功'),
                })
                this.queryOrderList()
              }
            },
          })
        },
      })
    },
    confirmSelect() {
      let is_empty = false
      if (this.selectedRowKeys.length === 0) {
        is_empty = true
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.SelectAtLeastOneItem`),
        })
      }
      return is_empty
    },
    batchHandle({ modalAction, url }) {
      if (this.confirmSelect()) return
      Modal.confirm({
        title: this.$t('form.Tips'),
        content: `${this.$t('form.Whether')} ${modalAction} ${this.$t('form.SelectOrder')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          let supplierReturnOrderIds = [...this.selectedRowKeys]
          this.commonHttp({
            url,
            modalAction,
            data: { supplierReturnOrderIds },
          }).then(() => {
            this.queryOrderList()
          })
        },
      })
    },
    commonHttp({ url, modalAction, data }) {
      return new Promise((resolve) => {
        http({
          instance: this,
          type: 'post',
          hasLoading: true,
          url,
          data,
          success: (res) => {
            this.$success({
              title: this.$t(`layer.Success`),
              content: `${modalAction}${this.$t('form.FINISH')}`,
            })
            resolve(res)
          },
        })
      })
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    handleChange(info) {
      this.shopCode = JSON.parse(localStorage.getItem('currentShop'))?.uniqueCode
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          this.queryOrderList()
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.time-item {
  font-size: 13px;
}
.platform-refund-quick {
  display: flex;
  align-items: center;
  min-height: 32px;
}
</style>
